import { Injectable, isDevMode } from '@angular/core';
import moment from 'moment-timezone';
import { MessageService } from 'primeng/api';
import { BehaviorSubject, Subject } from 'rxjs';
import { CheckDto } from 'src/app/shared/models/check-dto';
import { CheckSeat } from 'src/app/shared/models/check-seat.model';
import { CheckV4Item } from 'src/app/shared/models/Check-v4-item.model';
import { CustomerSubscriptionItem } from 'src/app/shared/models/CustomerSubscription.item';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { ProductUseMetric } from 'src/app/shared/models/DTO/productUseMetric.dto';
import { VenueFinance } from 'src/app/shared/models/DTO/VenueFinance.dto';
import { EmployeeAutomaticMessageItem } from 'src/app/shared/models/EmployeeAutomaticMessage.item';
import { EmployeeRecord } from 'src/app/shared/models/EmployeeRecord.model';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { CustomerSubscriptionFrequency } from 'src/app/shared/models/enums/customer-subscription-frequency.enum';
import { LicenseTypes } from 'src/app/shared/models/enums/license-types';
import { NotificationSource } from 'src/app/shared/models/enums/notificationSource.enum';
import { VenueWebsocketMessage } from 'src/app/shared/models/enums/venue-websocket-message.enum';

import { Job } from 'src/app/shared/models/focusDataModels/Job';
import { Station } from 'src/app/shared/models/focusDataModels/Station';
import { FocusPayDevice } from 'src/app/shared/models/FocusPay/FocusPayDevice.model';
import { IntegratorRequest } from 'src/app/shared/models/IntegratorRequest.model';
import { LaborSetupItem } from 'src/app/shared/models/laborScheduling/LaborSetup.item';
import { LaborShift } from 'src/app/shared/models/laborScheduling/LaborShift.model';
import { License } from 'src/app/shared/models/license.model';
import { OOCanvas } from 'src/app/shared/models/oo-canvas';
import { OOCanvasMenuItem } from 'src/app/shared/models/oo-canvas-menu-item.model';
import { OOLink } from 'src/app/shared/models/oo-link';
import { OOMenu } from 'src/app/shared/models/oo-menu';
import { OOMenuConfig } from 'src/app/shared/models/oo-menu-config';
import { OOMenuItem } from 'src/app/shared/models/oo-menu-item';
import { OOMenuItemCanvas } from 'src/app/shared/models/oo-menu-item-canvas.model';
import { OOMenuStatus } from 'src/app/shared/models/oo-menu-status';
import { OOOrderType } from 'src/app/shared/models/oo-order-type';
import { OOPriceLevel } from 'src/app/shared/models/oo-price-level';
import { OOStyles } from 'src/app/shared/models/oo-styles';
import { OOTags } from 'src/app/shared/models/oo-tags.model';
import { OOVenue } from 'src/app/shared/models/oo-venue';
import { OOIntegratorPrice } from 'src/app/shared/models/OOIntegratorPrice.item';
import { OOPromoCode } from 'src/app/shared/models/OOPromoCode.item';
import { OOTimeRanges } from 'src/app/shared/models/OOTimeRanges.entity';
import { PrintOrder } from 'src/app/shared/models/PrintOrder';
import { ProductUseItem } from 'src/app/shared/models/ProductUse.item';
import { SalesSummary } from 'src/app/shared/models/SalesSummary.model';
import { Store } from 'src/app/shared/models/store';
import { TimecardRecord } from 'src/app/shared/models/TimecardRecord.model';
import { VenueStatus } from 'src/app/shared/models/VenueStatus.model';
import { AppService } from './app.service';
import { CommandCenterService } from './command-center.service';
import { FocusdataService } from './focusdata.service';
import { FocuslinkService } from './focuslink.service';
import { VenueSocketService } from './venue-socket.service';

@Injectable({
	providedIn: 'root',
})
export class OOVenueService {
	automaticEmployeeMessageList: BehaviorSubject<EmployeeAutomaticMessageItem[]> = new BehaviorSubject<EmployeeAutomaticMessageItem[]>([]);
	canvasList: BehaviorSubject<OOCanvas[]> = new BehaviorSubject<OOCanvas[]>([]);
	menuItemList: BehaviorSubject<OOMenuItem[]> = new BehaviorSubject<OOMenuItem[]>([]);

	changeVenue: Subject<Store> = new Subject<Store>();
	checks: BehaviorSubject<CheckDto[]> = new BehaviorSubject<CheckDto[]>([]);
	customCanvasOptions: any[] = [];

	displayVenueTools: Subject<boolean> = new Subject<boolean>();

	employeeList: BehaviorSubject<EmployeeRecord[]> = new BehaviorSubject<EmployeeRecord[]>([]);

	integratorRequestList: BehaviorSubject<IntegratorRequest[]> = new BehaviorSubject<IntegratorRequest[]>([]);

	jobList: BehaviorSubject<Job[]> = new BehaviorSubject<Job[]>([]);

	focusPayDeviceList: BehaviorSubject<FocusPayDevice[]> = new BehaviorSubject<FocusPayDevice[]>([]);
	futureOrderTimeSlots: any[];

	laborSetup: BehaviorSubject<LaborSetupItem> = new BehaviorSubject<LaborSetupItem>(undefined);
	laborShiftList: BehaviorSubject<LaborShift[]> = new BehaviorSubject<LaborShift[]>([]);

	licenses: BehaviorSubject<License[]> = new BehaviorSubject<License[]>([]);
	licensesKitchenDevice: BehaviorSubject<License[]> = new BehaviorSubject<License[]>([]);
	licensesOnDevice: BehaviorSubject<License[]> = new BehaviorSubject<License[]>([]);
	menuOptions = [];
	ooCanvases: OOCanvas[] = [];
	ooLinks: OOLink[] = [];
	ooIntegratorPrice: OOIntegratorPrice[] = [];
	ooMenus: OOMenu[] = [];
	ooMenuConfig: OOMenuConfig;
	ooMenuItems: OOMenuItem[] = [];
	ooMenuStatus: OOMenuStatus;
	ooMenuStatusDetail = {
		lastUpdate: null,
		message: null,
		current: true,
	};
	ooOrderTypes: OOOrderType[];
	ooPromoCodes: OOPromoCode[];
	ooStyles: OOStyles;
	ooTags: OOTags[];
	ooVenue: OOVenue;
	ooVenueEdit: OOVenue;
	orderNotificationCheckKeys: string[] = [];

	printOrderJobs: BehaviorSubject<PrintOrder[]> = new BehaviorSubject<PrintOrder[]>([]);

	productStatistics: BehaviorSubject<ProductUseItem[]> = new BehaviorSubject<ProductUseItem[]>([]);
	productStatisticMetric: BehaviorSubject<ProductUseMetric> = new BehaviorSubject<ProductUseMetric>(new ProductUseMetric());

	priceLevels: BehaviorSubject<OOPriceLevel[]> = new BehaviorSubject<OOPriceLevel[]>([]);
	priceNumbers = [
		{ label: 'Price 1', value: 1 },
		{ label: 'Price 2', value: 2 },
		{ label: 'Price 3', value: 3 },
		{ label: 'Price 4', value: 4 },
		{ label: 'Price 5', value: 5 },
		{ label: 'Price 6', value: 6 },
		{ label: 'Price Sub', value: 7 },
		{ label: 'Price Extra', value: 8 },
		{ label: 'Price No', value: 9 },
		{ label: 'Price Mod', value: 10 },
	];
	saving: boolean;

	salesSummaryList: BehaviorSubject<SalesSummary[]> = new BehaviorSubject<SalesSummary[]>([]);
	salesItemsList: BehaviorSubject<CheckV4Item[]> = new BehaviorSubject<CheckV4Item[]>([]);
	snapshot: string;
	snapshots: { label: string; value: string }[] = [];

	stationList: BehaviorSubject<Station[]> = new BehaviorSubject<Station[]>([]);

	storeConfigList: BehaviorSubject<GenericLabelValue[]> = new BehaviorSubject<GenericLabelValue[]>([]);
	storeLinkLogList: BehaviorSubject<GenericLabelValue[]> = new BehaviorSubject<GenericLabelValue[]>([]);

	timecardList: BehaviorSubject<TimecardRecord[]> = new BehaviorSubject<TimecardRecord[]>([]);

	timeRanges: OOTimeRanges[] = [];

	userOrderNotificationTone: number;

	venueKey: number;
	venueFinance: BehaviorSubject<VenueFinance> = new BehaviorSubject<VenueFinance>(new VenueFinance());

	subscriptionMenu: BehaviorSubject<OOCanvas[]> = new BehaviorSubject<OOCanvas[]>([]);

	subscriptionOOcanvas: BehaviorSubject<OOCanvas[]> = new BehaviorSubject<OOCanvas[]>([]);
	subscriptionOOlink: BehaviorSubject<OOLink[]> = new BehaviorSubject<OOLink[]>([]);
	subscriptionOOintegratorPrice: BehaviorSubject<OOIntegratorPrice[]> = new BehaviorSubject<OOIntegratorPrice[]>([]);
	subscriptionOOmenu: BehaviorSubject<OOMenu[]> = new BehaviorSubject<OOMenu[]>([]);
	subscriptionOOmenuConfig: BehaviorSubject<OOMenuConfig> = new BehaviorSubject<OOMenuConfig>(new OOMenuConfig());
	subscriptionOOmenuItems: BehaviorSubject<OOMenuItem[]> = new BehaviorSubject<OOMenuItem[]>([]);
	subscriptionOOorderTypes: BehaviorSubject<OOOrderType[]> = new BehaviorSubject<OOOrderType[]>([]);
	subscriptionOOpromoCodes: BehaviorSubject<OOPromoCode[]> = new BehaviorSubject<OOPromoCode[]>([]);
	subscriptionOOTags: BehaviorSubject<OOTags[]> = new BehaviorSubject<OOTags[]>([]);
	subscriptionOOStyles: BehaviorSubject<OOStyles> = new BehaviorSubject<OOStyles>(new OOStyles());
	subscriptionOOvenue: BehaviorSubject<OOVenue> = new BehaviorSubject<OOVenue>(new OOVenue());
	subscriptionTimeRanges: BehaviorSubject<OOTimeRanges[]> = new BehaviorSubject<OOTimeRanges[]>([]);
	subscriptionVenueKey: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	subscriptionVenue: BehaviorSubject<Store> = new BehaviorSubject<Store>(new Store());
	subscriptionVenueMessage: Subject<any> = new Subject<any>();

	timecardRecordList: BehaviorSubject<TimecardRecord[]> = new BehaviorSubject<TimecardRecord[]>([]);

	venueMessageList: BehaviorSubject<SocketMessage[]> = new BehaviorSubject<SocketMessage[]>([]);

	constructor(
		public app: AppService,
		public focuslink: FocuslinkService,
		public focusdata: FocusdataService,
		private msgSvc: MessageService,
		private venueSocket: VenueSocketService,
		private commandCenter: CommandCenterService
	) {}

	canvasSet(canvasList: OOCanvas[]): OOCanvas[] {
		this.canvasList.next(canvasList);
		return this.canvasList.value;
	}

	async canvasesGet() {
		const resp = await this.focuslink.getOOCanvases(this.venueKey);
		this.ooCanvases = resp.map((i) => new OOCanvas(i));
		this.ooCanvases.forEach((can) => {
			can.countOnline = can.menuItems.filter((i) => i.online).length;
			can.menuItems.forEach((cmi) => (cmi.ooMenuItem = this.ooMenuItems.find((item) => item.menuItemKey === cmi.menuItemKey)));
		});
		this.menuItemsAttachCanvases();
		this.subscriptionOOcanvas.next(this.ooCanvases);
		this.app.loading(false);
	}

	async canvaseSave(canvas: OOCanvas | OOCanvas[]) {
		let can;
		if (Array.isArray(canvas)) {
			can = [...canvas];
			can.forEach((c, idx) => {
				if (c.menuItems) {
					delete c.menuItems;
				}
			});
		} else {
			can = { ...canvas };
			if (can.menuItems) {
				delete can.menuItems;
			}
		}

		await this.focuslink.canvasPost(this.venueKey, can);

		if (Array.isArray(canvas)) {
			canvas.forEach((c) => {
				const idx = this.ooCanvases.findIndex((i) => i.canvasKey === c.canvasKey);
				if (idx === -1) {
					this.ooCanvases.push(c);
				} else {
					this.ooCanvases[idx] = c;
				}
			});
		} else {
			const idx = this.ooCanvases.findIndex((i) => i.canvasKey === canvas.canvasKey);
			if (idx === -1) {
				this.ooCanvases.push(canvas);
			} else {
				this.ooCanvases[idx] = canvas;
			}
		}

		this.ooCanvases.forEach((can) => {
			if (can.includedItemCanvas) {
				can.countOnline = can.menuItems?.length;
			} else {
				can.countOnline = can.menuItems?.filter((i) => i.online).length;
			}
		});
		this.sortForDisplay(this.ooCanvases);
		this.subscriptionOOcanvas.next(this.ooCanvases);
		return this.ooCanvases;
	}

	async canvasDelete(canvasKey: number) {
		this.focuslink.canvasDelete(this.venueKey, canvasKey);
		const deletedCanvasIndex = this.ooCanvases.findIndex((i) => i.canvasKey === canvasKey);
		// const deletedCanvasSortOrder = this.ooCanvases[deletedCanvasIndex].sortOrder;
		this.ooCanvases.splice(deletedCanvasIndex, 1);
		// if (deletedCanvasSortOrder) {
		// 	const canvasesToReorder = this.ooCanvases.filter((i) => i.sortOrder && i.sortOrder > deletedCanvasSortOrder);
		// 	let newSortOrder = deletedCanvasSortOrder;
		// 	canvasesToReorder.forEach((remainingCanvas) => {
		// 		remainingCanvas.sortOrder = newSortOrder;
		// 		newSortOrder += 1;
		// 	});
		// 	this.canvaseSave(canvasesToReorder);
		// }
		this.subscriptionOOcanvas.next(this.ooCanvases);
	}

	async canvasMenuItemSave(cmi: OOCanvasMenuItem) {
		try {
			const saveCmi = { ...cmi };
			saveCmi.unsaved && delete saveCmi.unsaved;
			delete saveCmi.ooMenuItem;
			delete saveCmi.ooCanvas;
			await this.focuslink.canvasMenuItemPost(this.venueKey, cmi.canvasKey, saveCmi);
			cmi.price = cmi.priceNumber === 1 ? cmi.ooMenuItem.price : cmi.ooMenuItem[`price${cmi.priceNumber}`];
			cmi.unsaved = false;
			const existCanvas = this.ooCanvases.find((i) => i.canvasKey === cmi.canvasKey);
			const existCmi = existCanvas.menuItems?.find((i) => i.menuItemKey === cmi.menuItemKey);
			cmi.ooCanvas = cmi.ooCanvas ? cmi.ooCanvas : existCanvas;
			if (existCmi) {
				Object.assign(existCmi, cmi);
			} else {
				if (!existCanvas.menuItems) {
					existCanvas.menuItems = [];
				}
				existCanvas.menuItems.push(cmi);
			}

			this.app.msgSvc.add({
				severity: AppMessageSeverity.GREEN,
				summary: '',
				detail: `Canvas item ${cmi.displayName || cmi.ooMenuItem.name} saved successfully`,
			});
			this.subscriptionOOcanvas.next(this.ooCanvases);
		} catch (error) {
			this.app.msgSvc.add({
				severity: AppMessageSeverity.RED,
				summary: '',
				detail: `Saving item ${cmi.displayName || cmi.ooMenuItem.name} failed.`,
			});
			console.log(error);
		}
	}

	async canvasMenuItemRemove(menuItemKey: number, canvasKey: number) {
		await this.focuslink.canvasMenuItemDelete(this.venueKey, canvasKey, menuItemKey);
		const canvasIdx = this.ooCanvases.findIndex((i) => i.canvasKey === canvasKey);
		const cmiIdx = this.ooCanvases[canvasIdx].menuItems.findIndex((i) => i.menuItemKey === menuItemKey);
		this.ooCanvases[canvasIdx].menuItems.splice(cmiIdx, 1);
		this.subscriptionOOcanvas.next(this.ooCanvases);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `Canvas item removed.` });
		return this.ooCanvases;
	}

	async venueFinanceInit(venueKey?: number) {
		const resp = await this.focuslink.contractFinanceGet(venueKey || this.venueKey);
		const venueFinance = new VenueFinance(resp);
		venueFinance.invoices?.sort((a, b) => (a.createdDate < b.createdDate ? 1 : -1));
		venueFinance.contracts?.sort((a, b) => (a.endDate < b.endDate ? 1 : -1));
		venueFinance.subscriptions?.sort((a, b) => (a.startDate < b.startDate ? 1 : -1));
		venueFinance.paymentProfiles?.sort((a, b) => (a.createdDate < b.createdDate ? 1 : -1));
		this.venueFinance.next(venueFinance);
		return this.venueFinance.value;
	}

	async employeeListGet(venueKey: number): Promise<EmployeeRecord[]> {
		const resp = await this.focuslink.configsEmployees(venueKey);
		this.employeeList.next(resp.map((i) => new EmployeeRecord(i)));
		return this.employeeList.value;
	}

	async jobListGet(venueKey: number): Promise<Job[]> {
		const resp = await this.focuslink.configsJobs(venueKey);
		this.jobList.next(resp.map((i) => new Job(i)));
		return this.jobList.value;
	}

	async laborSetupGet(venueKey: number): Promise<LaborSetupItem> {
		const resp = await this.focuslink.laborSetupGet(venueKey);
		this.laborSetup.next(new LaborSetupItem(resp));
		return this.laborSetup.value;
	}

	async laborShiftGet(venueKey: number): Promise<LaborShift[]> {
		const resp = await this.focuslink.laborShiftGetAll(venueKey);
		this.laborShiftList.next(resp.map((i) => new LaborShift(i)));
		return this.laborShiftList.value;
	}

	async initVenue(venueKey: number) {
		this.venueKey = venueKey;
		this.subscriptionVenueKey.next(venueKey);
		this.ooVenueGet();
		this.ooStylesGet();
		await this.menuItemsGet();
		this.canvasesGet();
		this.timeRangesGet();

		this.venueSocketConnect(venueKey);
		this.venueMessage();

		return;
	}

	getIntegration(appId: string) {
		const integration = this.ooVenue.oAuthIntegrations?.find((i) => i.appId === appId);
		if (integration) {
			if (moment.utc(integration.expirationDateTime).isAfter(moment.utc())) {
				integration.status = 1;
			}
			if (moment.utc(integration.expirationDateTime).isBefore(moment.utc())) {
				integration.status = 0;
			}
		}

		return integration;
	}

	async integratorPriceGet() {
		const resp = await this.focuslink.integratorPriceGet(this.venueKey);
		this.ooIntegratorPrice = resp.map((i) => new OOIntegratorPrice(i));
		this.subscriptionOOintegratorPrice.next(this.ooIntegratorPrice);
	}

	async integratorPricePost(integratorPrice: OOIntegratorPrice) {
		await this.focuslink.integratorPricePost(this.venueKey, integratorPrice);
		const idx = this.ooIntegratorPrice.findIndex((i) => i.key === integratorPrice.key);
		if (idx === -1) {
			this.ooIntegratorPrice.push(integratorPrice);
		} else {
			this.ooIntegratorPrice[idx] = integratorPrice;
		}

		this.subscriptionOOintegratorPrice.next(this.ooIntegratorPrice);
	}

	async integratorPriceDelete(integratorPrice: OOIntegratorPrice) {
		await this.focuslink.integratorPriceDelete(this.venueKey, integratorPrice.key);
		this.ooIntegratorPrice.splice(
			this.ooIntegratorPrice.findIndex((i) => i.key === integratorPrice.key),
			1
		);
		this.subscriptionOOintegratorPrice.next(this.ooIntegratorPrice);
	}

	async integratorRequestListGet(venueKey?: number) {
		const resp = await this.focuslink.integratorRequestGetAll(venueKey || this.venueKey);
		this.integratorRequestList.next(resp.map((i) => new IntegratorRequest(i)));
		return this.integratorRequestList.value;
	}

	async integratorRequestGetOne(venueKey: number, requestId: string) {
		const resp = await this.focuslink.integratorRequestGetOne(venueKey, requestId);
		this.integratorRequestList.value.push(new IntegratorRequest(resp));
		this.integratorRequestList.value.sort((a, b) => (a.created < b.created ? 1 : -1));
		this.integratorRequestList.next(this.integratorRequestList.value);
		return this.integratorRequestList.value;
	}

	async licensesGet(venueKey?: number, licensePayload?: License[]) {
		if (licensePayload) {
			this.licenses.next(licensePayload);
		} else {
			const resp = await this.focuslink.licensesGetByVenue(this.venueKey || venueKey);
			this.licenses.next(
				resp.map((i) => {
					const license = new License(i);
					license.printerId = license.printerId ? +license.printerId : undefined;
					if (license.features && license.features.bumpFromPrinterIdList?.length > 0) {
						license.features.bumpFromPrinterIdList = license.features.bumpFromPrinterIdList.map((i) => +i);
					}
					return license;
				})
			);
		}

		this.licensesKitchenDevice.next(this.licenses.value.filter((i) => i.type === LicenseTypes.KitchenDevice));
		this.licensesOnDevice.next(this.licenses.value.filter((i) => i.type === LicenseTypes.OnDevice));

		return this.licenses.value;
	}

	async focusPayDeviceGet(venueKey: number) {
		this.focusPayDeviceList.next([]);
		const resp = await this.focuslink.focusPayDeviceGet(venueKey);
		this.focusPayDeviceList.next(
			resp.map((i) => {
				const d = new FocusPayDevice(i);
				d.deviceId = `${d.type}-${d.key}`;
				return d;
			})
		);

		return this.focusPayDeviceList.value;
	}

	async menuGet() {
		const resp = await this.focuslink.menuGet(this.venueKey);
		this.ooMenus = resp.map((i) => new OOMenu(i));
		if (this.ooMenus.some((i) => i.key === '0')) {
			this.ooMenus.unshift(
				new OOMenu({
					venueKey: this.venueKey,
					key: '0',
					name: 'Default',
					active: this.ooMenus.filter((i) => i.active).length === 0 ? true : false,
				})
			);
		}

		this.subscriptionOOmenu.next(this.ooMenus);
		return this.ooMenus;
	}

	async menuSave(ooMenu: OOMenu | OOMenu[]) {
		await this.focuslink.menuPost(this.venueKey, ooMenu);
		this.menuGet();
	}

	async menuDelete(ooMenu: OOMenu) {
		await this.focuslink.menuDelete(this.venueKey, ooMenu.key);
		this.subscriptionOOmenu.value.splice(
			this.subscriptionOOmenu.value.findIndex((i) => i.key === ooMenu.key),
			1
		);
		this.subscriptionOOmenu.next(this.subscriptionOOmenu.value);
		return this.subscriptionOOmenu.value;
	}

	async menuItemGet(menuItemKey: number) {
		const resp = await this.focuslink.menuItemGetOne(this.venueKey, menuItemKey);
		return new OOMenuItem(resp);
	}

	menuItemsAttachCanvases() {
		this.ooMenuItems.forEach((item) =>
			item.canvases.forEach((mic) => {
				const canvas = this.ooCanvases.find((c) => c.canvasKey === mic.canvasKey);
				Object.assign(mic, canvas);
			})
		);
	}

	menuItemPriceValue(value: number) {
		if (value >= 0) {
			value = +value;
			return ` - $${value.toFixed(2)}`;
		} else {
			return '';
		}
	}

	menuItemPriceOptions(ooMenuItem?: OOMenuItem) {
		if (!ooMenuItem)
			return [
				{ label: `Price 1`, value: 1 },
				{ label: `Price 2`, value: 2 },
				{ label: `Price 3`, value: 3 },
				{ label: `Price 4`, value: 4 },
				{ label: `Price 5`, value: 5 },
				{ label: `Price 6`, value: 6 },
				{ label: 'Sub', value: 7 },
				{ label: 'Extra', value: 8 },
				{ label: 'No', value: 9 },
				{ label: 'Mod', value: 10 },
			];
		if (ooMenuItem.priceLevel && this.priceLevels.value.length > 0) {
			const applicablePriceLevel = this.priceLevels.value.find((i) => i.priceLevelKey === ooMenuItem.priceLevel);
			if (applicablePriceLevel) {
				return [
					{
						label: (applicablePriceLevel.priceName1 || applicablePriceLevel.priceDisplayName1) + this.menuItemPriceValue(ooMenuItem.price),
						value: 1,
					},
					{
						label: (applicablePriceLevel.priceName2 || applicablePriceLevel.priceDisplayName2) + this.menuItemPriceValue(ooMenuItem.price2),
						value: 2,
					},
					{
						label: (applicablePriceLevel.priceName3 || applicablePriceLevel.priceDisplayName3) + this.menuItemPriceValue(ooMenuItem.price3),
						value: 3,
					},
					{
						label: (applicablePriceLevel.priceName4 || applicablePriceLevel.priceDisplayName4) + this.menuItemPriceValue(ooMenuItem.price4),
						value: 4,
					},
					{
						label: (applicablePriceLevel.priceName5 || applicablePriceLevel.priceDisplayName5) + this.menuItemPriceValue(ooMenuItem.price5),
						value: 5,
					},
					{
						label: (applicablePriceLevel.priceName6 || applicablePriceLevel.priceDisplayName6) + this.menuItemPriceValue(ooMenuItem.price6),
						value: 6,
					},
					{ label: 'Sub' + this.menuItemPriceValue(ooMenuItem.priceSub), value: 7 },
					{ label: 'Extra' + this.menuItemPriceValue(ooMenuItem.priceExtra), value: 8 },
					{ label: 'No' + this.menuItemPriceValue(ooMenuItem.priceNo), value: 9 },
					{ label: 'Mod' + this.menuItemPriceValue(ooMenuItem.priceMod), value: 10 },
				];
			}
		}
		return [
			{ label: 1 + this.menuItemPriceValue(ooMenuItem.price), value: 1 },
			{ label: 2 + this.menuItemPriceValue(ooMenuItem.price2), value: 2 },
			{ label: 3 + this.menuItemPriceValue(ooMenuItem.price3), value: 3 },
			{ label: 4 + this.menuItemPriceValue(ooMenuItem.price4), value: 4 },
			{ label: 5 + this.menuItemPriceValue(ooMenuItem.price5), value: 5 },
			{ label: 6 + this.menuItemPriceValue(ooMenuItem.price6), value: 6 },
			{ label: 'Sub' + this.menuItemPriceValue(ooMenuItem.priceSub), value: 7 },
			{ label: 'Extra' + this.menuItemPriceValue(ooMenuItem.priceExtra), value: 8 },
			{ label: 'No' + this.menuItemPriceValue(ooMenuItem.priceNo), value: 9 },
			{ label: 'Mod' + this.menuItemPriceValue(ooMenuItem.priceMod), value: 10 },
		];
	}

	menuItemGetPriceFromNumber(item: OOMenuItem, applicablePriceNumber?: number) {
		let price = 0;
		const priceNumber = applicablePriceNumber || item.priceNumber;
		if (item) {
			price = item.price;
			switch (priceNumber) {
				case 1: {
					return item.price;
				}
				case 2: {
					return item.price2;
				}
				case 3: {
					return item.price3;
				}
				case 4: {
					return item.price4;
				}
				case 5: {
					return item.price5;
				}
				case 6: {
					return item.price6;
				}
				case 7: {
					return item.priceSub;
				}
				case 8: {
					return item.priceExtra;
				}
				case 9: {
					return item.priceNo;
				}
				case 10: {
					return item.priceMod;
				}
			}
		}
		return +price;
	}

	async menuItemCanvasGet(menuItemKey: number) {
		const resp = await this.focuslink.menuItemCanvasGet(this.venueKey, menuItemKey);
		return resp.filter((i) => i.ooCanvas).map((i) => new OOMenuItemCanvas(i));
	}

	async menuItemsGet() {
		const resp = await this.focuslink.getOOMenuItems(this.venueKey);
		this.ooMenuItems = resp.map((i) => new OOMenuItem(i));

		this.subscriptionOOTags.subscribe((tags) => {
			this.ooMenuItems.forEach((item) => {
				if (item.OOMenuItemTags?.length > 0) {
					item.OOMenuItemTags.forEach((tag) => {
						tag.OOTags === tags.find((i) => i.key === tag.tagKey);
					});
				}
			});
		});

		this.ooMenuItems.sort((a, b) => (a.menuItemKey > b.menuItemKey ? 1 : -1));

		this.subscriptionOOmenuItems.next(this.ooMenuItems);
	}

	async menuItemsSave(menuItem: OOMenuItem | OOMenuItem[]) {
		await this.focuslink.menuItemPost(this.venueKey, menuItem);
		this.subscriptionOOmenuItems.next(this.ooMenuItems);
	}

	async ooLinksGet() {
		const resp = await this.focuslink.linkKeyGet(this.venueKey);
		this.ooLinks = resp.map((i) => new OOLink(i));
		this.subscriptionOOlink.next(this.ooLinks);
	}

	async ooLinkSave(link: OOLink | OOLink[]) {
		const resp = await this.focuslink.linkKeyPost(this.venueKey, link);
		this.ooLinksGet();
	}

	async ooLinkDelete(link: OOLink) {
		await this.focuslink.linkKeyDelete(this.venueKey, link.key);
		this.ooLinks.splice(
			this.ooLinks.findIndex((i) => i.key === link.key),
			1
		);
		this.subscriptionOOlink.next(this.ooLinks);
	}

	async ooMenuConfigGet() {
		const resp = await this.focuslink.getOOMenuConfig(this.venueKey);
		this.ooMenuConfig = new OOMenuConfig(resp);
		this.subscriptionOOmenuConfig.next(this.ooMenuConfig);
	}

	async ooMenuConfigSave(ooMenuConfig?: OOMenuConfig) {
		if (ooMenuConfig) {
			await this.focuslink.saveOOMenuConfig(ooMenuConfig.venueKey, ooMenuConfig);
			this.ooMenuConfig = ooMenuConfig;
		} else {
			await this.focuslink.saveOOMenuConfig(this.venueKey, this.ooMenuConfig);
		}
	}

	async ooOrderTypeGet() {
		const resp = await this.focuslink.orderTypeGet(this.venueKey);
		this.ooOrderTypes = resp.map((i) => new OOOrderType(i));
		this.subscriptionOOorderTypes.next(this.ooOrderTypes);
	}

	async ooOrderTypeSave(orderType: OOOrderType) {
		const resp = await this.focuslink.orderTypePost(this.venueKey, orderType);
		if (!orderType.key) {
			orderType.key = resp.key;
		}
		this.ooOrderTypeGet();
		this.subscriptionOOorderTypes.next(this.ooOrderTypes);
		return resp;
	}

	async ooOrderTypeDelete(orderType: OOOrderType) {
		const idx = this.ooOrderTypes.findIndex((i) => i.key === orderType.key);

		await this.focuslink.orderTypeDelete(this.venueKey, orderType.key);
		this.ooOrderTypes.splice(idx, 1);
		this.subscriptionOOorderTypes.next(this.ooOrderTypes);
	}

	async ooPriceLevelGet() {
		const resp = await this.focuslink.priceLevelGet(this.venueKey);
		this.priceLevels.next(resp.map((i) => new OOPriceLevel(i)));
		return this.priceLevels.value;
	}

	async ooPromoCodeGet() {
		const resp = await this.focuslink.promoCodeGetAll(this.venueKey);
		this.ooPromoCodes = resp.map((i) => {
			const pc = new OOPromoCode(i);
			pc.menuItem = this.ooMenuItems.find((mi) => mi.menuItemKey === pc.menuItemKey);
			pc.requireMenuItems = [];

			pc.requiredMenuItemKeys?.forEach((rmi) => {
				pc.requireMenuItems.push(this.ooMenuItems.find((mi) => mi.menuItemKey === rmi));
			});

			pc.applicableMenuItems = [];
			pc.applicableMenuItemKeys?.forEach((ami) => {
				pc.applicableMenuItems.push(this.ooMenuItems.find((mi) => mi.menuItemKey === ami));
			});
			pc.startDateDate = pc.startDate ? moment(pc.startDate).toDate() : undefined;
			pc.endDateDate = pc.endDate ? moment(pc.endDate).toDate() : undefined;
			return pc;
		});
		this.subscriptionOOpromoCodes.next(this.ooPromoCodes);
		return this.ooPromoCodes;
	}

	async ooPromoCodeSave(promoCode: OOPromoCode) {
		promoCode.startDate = promoCode.startDateDate ? moment(promoCode.startDateDate).format() : undefined;
		promoCode.endDate = promoCode.endDateDate ? moment(promoCode.endDateDate).format() : undefined;
		if (promoCode.sk) {
			await this.focuslink.promoCodePatch(this.venueKey, promoCode);
			promoCode.menuItem = this.ooMenuItems.find((itm) => itm.menuItemKey === promoCode.menuItemKey);
			promoCode.requiredMenuItemKeys?.forEach((rmi) => {
				promoCode.requireMenuItems.push(this.ooMenuItems.find((mi) => mi.menuItemKey === rmi));
			});

			promoCode.applicableMenuItems = [];
			promoCode.applicableMenuItemKeys?.forEach((ami) => {
				promoCode.applicableMenuItems.push(this.ooMenuItems.find((mi) => mi.menuItemKey === ami));
			});
			const existingIdx = this.ooPromoCodes.findIndex((i) => i.key === promoCode.key);
			this.ooPromoCodes[existingIdx] = promoCode;
		} else {
			const resp = await this.focuslink.promoCodePost(this.venueKey, promoCode);
			const pc = new OOPromoCode(resp);
			pc.menuItem = this.ooMenuItems.find((mi) => mi.menuItemKey === pc.menuItemKey);
			pc.requireMenuItems = [];
			pc.requiredMenuItemKeys?.forEach((rmi) => {
				pc.requireMenuItems.push(this.ooMenuItems.find((mi) => mi.menuItemKey === rmi));
			});
			pc.requiredMenuItemKeys?.forEach((rmi) => {
				pc.requireMenuItems.push(this.ooMenuItems.find((mi) => mi.menuItemKey === rmi));
			});

			pc.applicableMenuItems = [];
			pc.applicableMenuItemKeys?.forEach((ami) => {
				pc.applicableMenuItems.push(this.ooMenuItems.find((mi) => mi.menuItemKey === ami));
			});
			this.ooPromoCodes.push(pc);
		}

		this.subscriptionOOpromoCodes.next(this.ooPromoCodes);
		return this.ooPromoCodes;
	}

	async ooPromoCodeDelete(promoCode: OOPromoCode) {
		await this.focuslink.promoCodeDelete(this.venueKey, promoCode.key);
		this.ooPromoCodes.splice(
			this.ooPromoCodes.findIndex((i) => i.key === promoCode.key),
			1
		);
		this.subscriptionOOpromoCodes.next(this.ooPromoCodes);
		return this.ooPromoCodes;
	}

	async ooPromoCodeEnabled(transactionType: number) {
		try {
			const resp = await this.focuslink.promoCodeEnabled(this.venueKey, transactionType);
			return true;
		} catch (error) {
			return false;
		}
	}

	async ooStylesGet() {
		const resp = await this.focuslink.stylesGet(this.venueKey);
		this.ooStyles = new OOStyles(resp);
		this.subscriptionOOStyles.next(this.ooStyles);
		if (this.subscriptionOOvenue.value) {
			this.subscriptionOOvenue.value.styles = this.ooStyles;
			this.subscriptionOOvenue.next(this.subscriptionOOvenue.value);
		}
		return this.ooStyles;
	}

	async ooTagsGet() {
		const resp = await this.focuslink.tagsGet(this.venueKey);
		this.ooTags = resp.map((i) => new OOTags(i));
		this.subscriptionOOTags.next(this.ooTags);
	}

	async ooTagSave(tag: OOTags) {
		await this.focuslink.tagsPost(this.venueKey, tag);
		const idx = this.ooTags.findIndex((i) => i.key === tag.key);
		if (idx === -1) {
			this.ooTags.push(tag);
		} else {
			this.ooTags[idx] = tag;
		}

		this.ooTags.sort((a, b) => (a.name > b.name ? 1 : -1));
		this.subscriptionOOTags.next(this.ooTags);
	}

	async ooTagDelete(tag: OOTags) {
		await this.focuslink.tagsDelete(this.venueKey, tag.key);
		this.ooTags.splice(
			this.ooTags.findIndex((i) => i.key === tag.key),
			1
		);
		this.subscriptionOOTags.next(this.ooTags);
	}

	async ooVenueGet(venueKey?: number) {
		try {
			const resp = await this.focuslink.getOOVenue(venueKey || this.venueKey);
			this.ooVenue = new OOVenue(resp);
		} catch (error) {
			this.ooVenue = new OOVenue({
				venueKey: this.venueKey,
			});
		}

		this.subscriptionOOvenue.next(this.ooVenue);
		if (!this.subscriptionVenueKey.value && venueKey) {
			this.subscriptionVenueKey.next(venueKey);
		}
		return this.ooVenue;
	}

	async ooVenueSave(ooVenue?: OOVenue) {
		if (ooVenue) {
			await this.focuslink.saveOOVenue(this.venueKey, ooVenue);
			this.ooVenue = ooVenue;
		} else {
			await this.focuslink.saveOOVenue(this.ooVenue.venueKey, this.ooVenue);
		}
		this.subscriptionOOvenue.next(this.ooVenue);
	}

	async ooVenueStyleSave(ooStyles: OOStyles) {
		await this.focuslink.stylesPost(this.venueKey, ooStyles);
		this.ooVenue.styles = ooStyles;
		this.subscriptionOOvenue.next(this.ooVenue);
	}

	async checksGetOnline(venueKey: number, businessDate: string) {
		const resp = await this.focuslink.checksGetByParams(venueKey, `businessDate=${businessDate}&source=focus-onlineorder&minified=true`);
		if (resp) {
			this.checks.next(resp.map((i) => new CheckDto(i)));
		}
		return this.checks.value;
	}

	async printOrdersGet(venueKey?: number, start?: string, end?: string) {
		const resp = await this.focuslink.kitchenPrintOrderAll(
			venueKey || this.venueKey,
			start || this.app.moment().add(-7, 'days').format(),
			this.app.moment()
		);
		this.printOrderJobs.next(
			resp.map((i) => {
				const po = new PrintOrder(i);
				po.duration = po.duration < 0 ? Math.abs(po.duration) : po.duration;
				return po;
			})
		);
		return this.printOrderJobs.value;
	}

	async productStatisticGet(venueKey?: number) {
		this.productStatisticMetricGet(venueKey || this.venueKey);
		const resp = await this.focuslink.productUseGetByVenue(venueKey || this.venueKey);
		const productUse: ProductUseItem[] = resp.map((i) => new ProductUseItem(i));
		productUse.sort((a, b) => (a.useDateTime > b.useDateTime ? 1 : -1));
		this.productStatistics.next(productUse);
		return this.productStatistics.value;
	}

	async productStatisticMetricGet(venueKey?: number, start?: string, end?: string) {
		const resp = await this.focuslink.productUseMetric(venueKey || this.venueKey, start, end);
		this.productStatisticMetric.next(new ProductUseMetric(resp));
		return this.productStatisticMetric.value;
	}

	async refreshVenue(venueKey: number) {
		this.app.loading(true);
		if (venueKey !== this.venueKey) {
			this.app.devLog(`refreshVenue: ${venueKey}`);
			const previousVenueKey = this.venueKey;
			this.venueKey = venueKey;
			this.subscriptionVenueKey.next(this.venueKey);
			if (this.venueKey) {
				const venue = await this.venueGet();
				if (venueKey && this.venueSocket.connectionVenueKey !== venueKey) {
					this.venueSocket.disconnect(previousVenueKey, venueKey);
				}
				this.resetVenueService();

				this.subscriptionVenue.next(venue);
				console.log(this.subscriptionVenue.value.key);
				this.subscriptionVenueKey.next(venue.key);

				this.venueSocketConnect(venue.key);
				this.venueMessage();
				this.orderNotificationCheckKeys = [];
				this.ooVenueGet();
				if (venue.onlineOrder) {
					this.menuGet();
					await this.menuItemsGet();
					//this.canvasesGet();
					this.ooOrderTypeGet();
					this.ooLinksGet();

					this.ooPriceLevelGet();
					this.ooMenuConfigGet();
					this.timeRangesGet();
					this.ooPromoCodeGet();
					this.ooTagsGet();
					this.integratorPriceGet();
					this.employeeListGet(this.subscriptionVenue.value.key);
				}
			}
		}
		this.app.loading(false);
		return this.subscriptionVenue.value;
	}

	resetVenueService() {
		this.automaticEmployeeMessageList.next([]);
		this.employeeList.next([]);
		this.focusPayDeviceList.next([]);
		this.jobList.next([]);
		this.ooCanvases = [];
		this.ooMenuConfig = new OOMenuConfig();
		this.ooMenuItems = [];
		this.ooMenus = [];
		this.ooOrderTypes = [];
		this.ooPromoCodes = [];
		this.ooTags = [];
		this.ooVenue = new OOVenue();
		this.ooVenue = undefined;
		this.priceLevels.next([]);
		this.laborShiftList.next([]);
		this.laborSetup.next(undefined);
		this.printOrderJobs.next([]);
		this.productStatisticMetric.next(new ProductUseMetric());
		this.salesSummaryList.next([]);
		this.stationList.next([]);
		this.subscriptionOOcanvas.next([]);
		this.subscriptionOOmenu.next([]);
		this.subscriptionOOmenuItems.next([]);
		this.subscriptionOOorderTypes.next([]);
		this.subscriptionOOpromoCodes.next([]);
		this.subscriptionOOTags.next([]);
		this.subscriptionOOvenue.next(new OOVenue());
		this.subscriptionTimeRanges.next([]);
		this.subscriptionVenue.next(new Store());
		this.timecardList.next([]);
		this.timeRanges = [];
		this.venueFinance.next(new VenueFinance());
		this.venueKey = undefined;
	}

	async salesDashboardGet(venueKey: number, checkDate: string) {
		const resp = await this.focuslink.salesDashboard(venueKey, checkDate);
		this.salesSummaryList.value.push(new SalesSummary(resp));
		this.salesSummaryList.value.sort((a, b) => (a.checkDate > b.checkDate ? 1 : -1));
		this.salesSummaryList.next(this.salesSummaryList.value);
		return this.salesSummaryList.value;
	}

	async salesSummarV4GetOne(venueKey: number, checkDate: string) {
		const resp = await this.focuslink.salesSummaryV4GetOne(venueKey, checkDate);
		const ss = new SalesSummary(resp);
		const existingIdx = this.salesSummaryList.value.findIndex((i) => i.checkDate === ss.checkDate);
		if (existingIdx === -1) {
			this.salesSummaryList.value.push(ss);
		} else {
			this.salesSummaryList.value[existingIdx] = ss;
		}
		this.salesSummaryList.value.sort((a, b) => (a.checkDate < b.checkDate ? 1 : -1));
		this.salesSummaryList.next(this.salesSummaryList.value);
	}

	async salesSummayV4GetRange(venueKey: number, checkDate: string, endDate: string) {
		const resp = await this.focuslink.salesSummaryV4GetRange(venueKey, checkDate, endDate);
		if (this.salesSummaryList.value?.length === 0) {
			this.salesSummaryList.next(resp.map((i) => new SalesSummary(i)));
		} else {
			const val = this.salesSummaryList.value.concat(resp.map((i) => new SalesSummary(i)));
			val.sort((a, b) => (a.checkDate < b.checkDate ? 1 : -1));
			this.salesSummaryList.next(val);
		}
		return this.salesSummaryList.value;
	}

	async salesItemsV4GetRange(venueKey: number, startDate: string, endDate: string, individualPropertyReturn: boolean) {
		const resp = await this.focuslink.salesItemsV4GetRange(venueKey, startDate, endDate, individualPropertyReturn);
		if (this.salesItemsList.value?.length === 0) {
			this.salesItemsList.next(resp.map((i) => new CheckV4Item(i)));
		} else {
			const val = this.salesItemsList.value.concat(resp.map((i) => new SalesSummary(i)));
			val.sort((a, b) => (a.businessDate < b.businessDate ? 1 : -1));
			this.salesItemsList.next(val);
		}
		return this.salesItemsList.value;
	}

	async stationListGet(venueKey: number) {
		const resp = await this.focuslink.stationsGet(venueKey);
		this.stationList.next(resp.map((i) => new Station(i)));
		return this.stationList.value;
	}

	async venueGet() {
		const resp = await this.focuslink.venueGet(this.venueKey, true);
		const temp = new Store(resp);
		if (temp.licenses) {
			this.licensesGet(undefined, temp.licenses);
		}
		temp.integrators.forEach((integrator) => {
			temp.venueIntegrators.push(this.commandCenter.integratorList.value.find((int) => int.key === integrator));
		});

		this.venueStatus(temp.key);
		this.subscriptionVenue.next(temp);
		return this.subscriptionVenue.value;
	}

	async venueMessage(venueKey?: number) {
		if (this.venueKey) {
			this.venueSocket.socket.subscribe(
				(data) => {
					if (this.subscriptionVenue.value.key) {
						if (isDevMode()) {
							// console.log(`------MESSAGE FROM ABOVE-------`);
							// this.app.playAudio(this.userOrderNotificationTone, NotificationSource.NEWORDER);
							//this.app.msgSvc.add({ severity: AppMessageSeverity.YELLOW, summary: "", detail: `MESSAGE \n ${JSON.stringify(data)}` });
						}

						const venueMessage: SocketMessage = {
							action: data.action || data.message,
							message: data.message,
							receivedDateTime: new Date(),
							venueKey: venueKey || this.venueKey,
						};

						if (data.message === 'posCheckSave') {
							venueMessage.action = 'posCheckSave';
							venueMessage.message = `Check Save: ${data.payload.checkKey} :: ${data.payload.checkNumber}`;
						}

						if (data.action === 'sendOrderMessage') {
							venueMessage.message = `MSC Check ${data.payload.checkKey}`;
						}

						if (data.action === 'deviceStatusUpdate' && this.subscriptionVenue.value?.VenuePos?.devices?.length > 0) {
							venueMessage.message = `Device Update: ${data.deviceId}`;
							const device = this.subscriptionVenue.value.VenuePos.devices.find((d) => d.deviceId === data.deviceId);
							if (device) {
								device.lastPulse = moment().format();
								this.subscriptionVenue.next(this.subscriptionVenue.value);
							}
						}

						if (data.message === VenueWebsocketMessage.INTEGRATORUPDATE) {
							data.action = data.message;
							if (this.integratorRequestList.value.length > 0) {
								this.integratorRequestGetOne(this.venueKey, data.payload.requestId);
							}
						}

						if (data.message === VenueWebsocketMessage.SALESUPDATE) {
							data.action = data.message;
							if (this.subscriptionVenue.value.key) {
								this.salesDashboardGet(this.subscriptionVenue.value.key, data.payload.checkDate);
							}
						}

						if (data.message === 'posCheckSave' && data.payload.source === 'focus-onlineorder') {
							data.action = data.message;
							data.message = data.payload.source;
							if (!this.orderNotificationCheckKeys.some((i) => i === data.payload.checkKey)) {
								if (this.userOrderNotificationTone) {
									this.app.playAudio(this.userOrderNotificationTone, NotificationSource.NEWORDER);
									this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `New Online Order $${data.payload.total}` });
									this.orderNotificationCheckKeys.push(data.payload.checkKey);
								}
							}
						}
						if (data.message === VenueWebsocketMessage.MENUPDATE) {
							data.action = data.message;
							if (data.payload === 'rekeyComplete') {
								this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `Menu Rekey complete. Have a lovely day 🤗` });
							}
						}
						if (data === 'menuUpdate') {
							this.menuItemsGet();
							this.canvasesGet();
						}

						this.venueMessageList.value.push(venueMessage);
						this.venueMessageList.next(this.venueMessageList.value);

						this.subscriptionVenueMessage.next(data);
					}
				},
				(error) => {
					this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: '', detail: `SOCKET ERROR HAS OCCURRED` });
				}
			);
		}
	}

	async venueMessageDisconnect() {
		if (this.venueKey) {
			this.venueSocket.disconnect(this.venueKey);
		}
	}

	async venueSocketConnect(venueKey: number) {
		if (venueKey === 15413) {
			venueKey = 15201;
		}
		this.venueSocket.connect(venueKey);
		this.venueKey = this.venueKey ? this.venueKey : venueKey;
	}

	async venueStatus(venueKey?: number) {
		try {
			const resp = await this.focuslink.venueStatus(venueKey || this.venueKey);
			const venueStatus = new VenueStatus(resp);
			if (!this.subscriptionVenue.value.status) {
				return venueStatus;
			}
			this.subscriptionVenue.value.status = venueStatus;
			if (
				this.licenses.value.length > 0 &&
				this.licenses.value.some((i) => i.type === LicenseTypes.KitchenDevice) &&
				this.subscriptionVenue.value.status?.kitchenStatus?.length > 0
			) {
				this.licenses.value
					.filter((i) => i.type === LicenseTypes.KitchenDevice)
					.forEach((i) => {
						i.lastHeartbeat = this.subscriptionVenue.value.status.kitchenStatus.find((j) => j.deviceId === i.printerId)?.lastPulse;
					});
			}
			this.subscriptionVenue.next(this.subscriptionVenue.value);
			return this.subscriptionVenue.value.status;
		} catch (error) {
			console.log('venue status error', error);
		}
	}

	async timeRangesGet() {
		try {
			const resp = await this.focuslink.timeRangeGetAll(this.venueKey);
			this.timeRanges = resp.map((i) => new OOTimeRanges(i));
			this.timeRanges.forEach((tr) => {
				tr.startDate = tr.startDate ? moment(tr.startDate).toDate() : undefined;
				tr.endDate = tr.endDate ? moment(tr.endDate).toDate() : undefined;
				tr.OOTimeRangeTimes.forEach((trt) => {
					trt.startTime = trt.startTime ? (trt.startTime === '00:00' ? undefined : moment(trt.startTime, 'HH:mm').toDate()) : undefined;

					trt.startTime2 = trt.startTime2 ? (trt.startTime2 === '00:00' ? undefined : moment(trt.startTime2, 'HH:mm').toDate()) : undefined;

					trt.endTime = trt.endTime ? (trt.endTime === '00:00' ? undefined : moment(trt.endTime, 'HH:mm').toDate()) : undefined;

					trt.endTime2 = trt.endTime2 ? (trt.endTime2 === '00:00' ? undefined : moment(trt.endTime2, 'HH:mm').toDate()) : undefined;
				});

				tr.OOTimeRangeTimes.sort((a, b) => (a.day > b.day ? 1 : -1));
			});

			this.timeRanges.sort((a, b) => (a.name > b.name ? 1 : -1));

			this.subscriptionTimeRanges.next(this.timeRanges);
		} catch (error) {}
	}

	async timeRangesSave(timeRange: OOTimeRanges) {
		await this.focuslink.timeRangePost(this.venueKey, timeRange);
		const idx = this.timeRanges.findIndex((i) => i.key === timeRange.key);
		this.timeRanges[idx] = timeRange;
		this.subscriptionTimeRanges.next(this.timeRanges);
	}

	async timeRangeDelete(timeRange: OOTimeRanges) {
		await this.focuslink.timeRangeDelete(this.venueKey, timeRange.key);
		this.timeRanges.splice(
			this.timeRanges.findIndex((i) => i.key === timeRange.key),
			1
		);
		this.subscriptionTimeRanges.next(this.timeRanges);
	}

	async venueSave() {
		await this.focuslink.venuePost(this.venueKey, this.subscriptionVenue.value);
		this.subscriptionVenue.next(this.subscriptionVenue.value);
	}

	async assignVenue(venueKey: number) {
		this.resetVenueService();
		if (!this.commandCenter.initalized) {
			this.commandCenter.initCommandCenter();
		}

		const venue = this.refreshVenue(venueKey);

		return venue;
	}

	buildFutureOrderTimeSlots() {
		this.futureOrderTimeSlots = [];

		for (let i = 0; i < 7; i++) {
			this.futureOrderTimeSlots[i] = [];

			const mIdx = moment().day(i).hour(0).minute(0).second(0);
			for (let i2 = 0; i2 < 1440; i2 += 15) {
				let valid = false;

				let start1, end1, start2, end2;
				if (this.ooVenue.timeRanges) {
					start1 = this.ooVenue.timeRanges[`day${i + 1}Start1`];
					end1 = this.ooVenue.timeRanges[`day${i + 1}End1`];
					start2 = this.ooVenue.timeRanges[`day${i + 1}Start2`];
					end2 = this.ooVenue.timeRanges[`day${i + 1}End2`];
				}

				if (!start1 && !end1 && !start2 && !end2) {
					valid = true;
				}

				if (start1 && end1) {
					const mStart1 = moment().day(i).hour(+start1.split(':')[0]).minute(+start1.split(':')[1].replace('am', '').replace('pm', '')).second(0);
					if (+start1.split(':')[0] < 12 && start1.includes('pm')) {
						mStart1.add(12, 'hours');
					}
					if (+start1.split(':')[0] === 12 && start1.includes('am')) {
						mStart1.subtract(12, 'hours');
					}
					const mEnd1 = moment().day(i).hour(+end1.split(':')[0]).minute(+end1.split(':')[1].replace('am', '').replace('pm', '')).second(0);
					if (+end1.split(':')[0] < 12 && end1.includes('pm')) {
						mEnd1.add(12, 'hours');
					}
					if (+end1.split(':')[0] === 12 && end1.includes('am')) {
						mEnd1.subtract(12, 'hours');
					}
					if (mIdx.isBetween(mStart1, mEnd1, 'minutes', '[)')) {
						valid = true;
					}
				}

				if (start2 && end2) {
					const mStart2 = moment().day(i).hour(+start2.split(':')[0]).minute(+start2.split(':')[1].replace('am', '').replace('pm', '')).second(0);
					if (+start2.split(':')[0] < 12 && start2.includes('pm')) {
						mStart2.add(12, 'hours');
					}
					if (+start2.split(':')[0] === 12 && start2.includes('am')) {
						mStart2.subtract(12, 'hours');
					}
					const mEnd2 = moment().day(i).hour(+end2.split(':')[0]).minute(+end2.split(':')[1].replace('am', '').replace('pm', '')).second(0);
					if (+end2.split(':')[0] < 12 && end2.includes('pm')) {
						mEnd2.add(12, 'hours');
					}
					if (+end2.split(':')[0] === 12 && end2.includes('am')) {
						mEnd2.subtract(12, 'hours');
					}
					if (mIdx.isBetween(mStart2, mEnd2, 'minutes', '[)')) {
						valid = true;
					}
				}

				if (valid) {
					this.futureOrderTimeSlots[i].push({
						label: mIdx.format('hh:mm A'),
						value: mIdx.format('HH:mm'),
					});
				}

				mIdx.add(15, 'minutes');
			}
		}
	}

	parseSeat(checkSeat: CheckSeat[]): CheckSeat[] {
		checkSeat.forEach((seat) => {
			seat.payments?.forEach((payment) => {
				if (payment.token?.includes('DC4')) {
					payment.focusPayDatacap = true;
					payment.datacapAuthorization = JSON.parse(payment.authorization);
					payment.datacapAuthorization.PrintDataStringArray = [];
					for (let i = 1; i <= 40; i++) {
						if (payment.datacapAuthorization.PrintData[`Line${i}`]) {
							payment.datacapAuthorization.PrintDataStringArray.push(payment.datacapAuthorization.PrintData[`Line${i}`].substring(1));
						}
					}
				}
			});
			seat.transactions?.forEach((transaction) => {
				if (
					seat.payments.some(
						(seatPayment) => seatPayment.focusPayDatacap && seatPayment.datacapAuthorization?.TranResponse.PayAPI_Id === transaction.transId
					)
				) {
					transaction.focusPayDatacap = true;
				}
			});
		});
		return checkSeat;
	}

	async restoreSnapshot(snapshot?: string) {
		try {
			await this.focuslink.ooRestoreSnapshot(this.venueKey, snapshot);
			this.msgSvc.add({
				severity: 'success',
				detail: 'Snapshot restored: ' + snapshot,
			});
		} catch (error) {
			this.msgSvc.add({ severity: 'error', detail: 'Error' });
		}
	}

	async resyncMenu(snapshot?: string) {
		try {
			await this.focuslink.ooMenuLoad(this.venueKey, snapshot);
			this.snapshot = null;
			if (!snapshot) {
				this.msgSvc.add({
					severity: 'success',
					detail: 'Resync request sent to POS',
				});
			}
			if (snapshot) {
				this.msgSvc.add({
					severity: 'success',
					detail: 'Load menu from snapshot request sent: ' + snapshot,
				});
			}
		} catch (error) {
			this.msgSvc.add({ severity: 'error', detail: 'Error' });
		}
	}

	async save(ooVenue: OOVenue) {
		await this.focuslink.saveOOVenue(ooVenue.venueKey, ooVenue);
	}

	async saveVenue() {
		try {
			const resp = await this.focuslink.venueSave(this.subscriptionVenue.value.key, this.subscriptionVenue.value);
			this.subscriptionVenue.next(new Store(resp));
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({ severity: AppMessageSeverity.RED, summary: '', detail: `Error saving Venue Settings` });
		}
		return this.subscriptionVenue.value;
	}

	sortForDisplay(arr: any, log?: boolean) {
		return arr.sort((a, b) => {
			if (!a.canvasKey) {
				if (a.sortOrder >= 0 && b.sortOrder >= 0) {
					return a.sortOrder > b.sortOrder ? 1 : -1;
				} else {
					const sortA = a.displayName || a.name;
					const sortB = b.displayName || b.name;
					return sortA < sortB ? -1 : sortA > sortB ? 1 : 0;
				}
			}
			if (a.canvasKey) {
				if (a.min >= 0 && a.min !== b.min) {
					return a.min > b.min ? -1 : 1;
				} else if (a.sortOrder >= 0 && b.sortOrder >= 0) {
					return a.sortOrder > b.sortOrder ? 1 : -1;
				} else {
					const sortA = a.displayName || a.name;
					const sortB = b.displayName || b.name;
					return sortA < sortB ? -1 : sortA > sortB ? 1 : 0;
				}
			}
		});
	}

	async storeConfigurationArchiveGet(venueKey?: number) {
		const resp = await this.focuslink.posConfigurationArchive(venueKey || this.venueKey);
		const val: GenericLabelValue[] = resp.map(
			(i) =>
				new GenericLabelValue({
					value: i.key,
					label: this.app.moment(i.date).format('l'),
					sortVal: this.app.moment(i.date).unix(),
				})
		);
		val.sort((a, b) => (a.sortVal < b.sortVal ? 1 : -1));
		this.storeConfigList.next(val);
		return val;
	}

	async storeConfigurationLinkLogsGet(venueKey?: number) {
		const resp = await this.focuslink.posConfigurationLinkLogs(venueKey || this.venueKey);
		const val: GenericLabelValue[] = resp.map(
			(i) =>
				new GenericLabelValue({
					value: i.key,
					label: this.app.moment(i.date).add(1, 'day').format('l'),
					sortVal: this.app.moment(i.date).unix(),
				})
		);
		val.sort((a, b) => (a.sortVal < b.sortVal ? 1 : -1));
		this.storeLinkLogList.next(val);
		return val;
	}

	subscriptionMenuBuild() {
		const subscriptionCanvases = this.ooCanvases.filter((canvas) => canvas.subscriptionCanvas);

		subscriptionCanvases.forEach((canvas) => {
			canvas.menuItems.forEach((cmi) => {
				cmi.ooMenuItem = this.ooMenuItems.find((item) => item.menuItemKey === cmi.menuItemKey);
				cmi.price = this.menuItemGetPriceFromNumber(cmi.ooMenuItem, cmi.priceNumber);
			});
		});

		this.subscriptionMenu.next(subscriptionCanvases);
	}

	subscriptionFrequencyOptions() {
		const frequencyOptions: {
			label: string;
			value: number;
			disabled: boolean;
		}[] = [];
		for (const [k, v] of Object.entries(CustomerSubscriptionFrequency)) {
			if (!isNaN(+v)) {
				frequencyOptions.push({
					label: this.app.references.toTitleCase(k),
					value: +v,
					disabled: false,
				});
			}
		}

		return frequencyOptions;
	}

	subscriptionFrequencyToFrequencyDisplayName(freq: number): string {
		switch (freq) {
			case CustomerSubscriptionFrequency.ADHOC:
				return 'on-demand';
			case CustomerSubscriptionFrequency.ANNUAL:
				return 'annually';
			case CustomerSubscriptionFrequency.BIMONTHLY:
				return 'bi-monthly';
			case CustomerSubscriptionFrequency.BIWEEKLY:
				return 'bi-weekly';
			case CustomerSubscriptionFrequency.DAILY:
				return 'daily';
			case CustomerSubscriptionFrequency.MONTHLY:
				return 'monthly';
			case CustomerSubscriptionFrequency.QUARTERLY:
				return 'quarterly';
			case CustomerSubscriptionFrequency.SEMIANNUAL:
				return 'twice annually';
			case CustomerSubscriptionFrequency.WEEKLY:
				return 'weekly';
		}
	}

	async subscriptionGetMenuItemSubscriptions(menuItemKey: number) {
		const resp = await this.focuslink.menuItemGetSubscriptions(this.venueKey, menuItemKey);
		const item = this.ooMenuItems.find((i) => i.menuItemKey === menuItemKey);
		item.subscriptions = resp.map((i) => new CustomerSubscriptionItem(i));
		this.subscriptionOOmenuItems.next(this.ooMenuItems);
		return new OOMenuItem(item);
	}

	async timecardRecordGetList(venueKey: number, startDate: string, endDate?: string) {
		const resp = await this.focuslink.timecardRecordGetList(venueKey, startDate, endDate);
		const timecards = resp.map((i) => new TimecardRecord(i));
		if (this.timecardRecordList.value.length > 0) {
			timecards.forEach((tcr) => {
				const idx = this.timecardRecordList.value.findIndex((i) => i.id === tcr.id);
				if (idx !== -1) {
					this.timecardRecordList.value[idx] = tcr;
				} else {
					this.timecardRecordList.value.push(tcr);
				}
			});
			this.timecardRecordList.next(this.timecardRecordList.value);
		} else {
			this.timecardRecordList.next(timecards);
		}
		return this.timecardRecordList.value;
	}

	toggleActiveMenu(menu: OOMenu, value: Boolean) {
		this.ooVenue.ooMenus.forEach((m) => {
			m.active = false;
		});
		if (value) {
			menu.active = true;
		}
		this.updateMenuOptions();
	}

	updateMenuOptions() {
		this.menuOptions = [];
		this.menuOptions.push({
			label: 'Default',
			value: '0',
		});
		this.ooVenue.ooMenus.forEach((m) => {
			this.menuOptions.push({
				label: m.name,
				value: m.key,
			});
		});
	}
}

interface SocketMessage {
	action?: string;
	key?: string;
	message?: string;
	receivedDateTime?: Date;
	venueKey?: number;
}
